<button type="button" class="btn" title="Filter Companies" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</button>

<div bsModal #companyFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width:1000px;">
        <div class="modal-content">
            <form (ngSubmit)="applyFilter()">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="applyFilter()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Companies</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Company Name</label>
                                </div>
                                <input name="CompanyFilterName" type="text" class="form-control" placeholder="Company Name" [(ngModel)]="name" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Operates at</label>
                                </div>
                                <select name="selectedMinesitesCompanyFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedMinesites">
                                    <ng-container *ngIf="live">
                                        <option *ngFor="let minesite of minesites" [value]="minesite.Id">{{ minesite.Name }}</option>
                                    </ng-container>
                                    <ng-container *ngIf="!live">
                                        <option *ngFor="let minesite of minesites" [value]="minesite.Minesite_ID">{{ minesite.Name }}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Owns Model</label>
                                </div>
                                <select name="selectedModelsCompanyFilter" class="form-control" size="5" multiple="multiple" [(ngModel)]="selectedModels" >
                                    <option *ngFor="let model of models" [value]="model.Id">{{ model.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Status</label>
                                </div>
                                <div class="btn-group btn-group-justified">
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="activeCompanies" [class.btn-warning]="!activeCompanies" (click)="activeCompanies = !activeCompanies">
                                            {{ activeCompanies ? 'Hide' : 'Show' }} Active Companies
                                        </button>
                                    </div>
                                    <div class="btn-group">
                                        <button type="button" class="btn" [class.btn-success]="inActiveCompanies" [class.btn-warning]="!inActiveCompanies" (click)="inActiveCompanies = !inActiveCompanies">
                                            {{ inActiveCompanies ? 'Hide' : 'Show' }} Inactive Companies
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </form>
        </div>
    </div>
</div>